// extracted by mini-css-extract-plugin
export default {"footer_link":"FooterLink_footer_link__S6lXh"};